import colors from '../colors.js';
var se = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");
export { se as default };
//# sourceMappingURL=Dark2.js.map
